import React, { useState } from "react";
import {
  SearchState,
  IntegratedFiltering,
  SortingState,
  IntegratedSorting,
} from "@devexpress/dx-react-grid";
import {
  Grid,
  Table,
  TableHeaderRow,
  Toolbar,
  SearchPanel,
} from "@devexpress/dx-react-grid-material-ui";

const getRowId = (row) => {
  return row.managementId;
};

export default function AssignmentsTable(props) {
  const [tableColumnExtensions] = useState([
    { columnName: "jobId", width: "25%" },
    { columnName: "assignmentName", width: "25%" },
    { columnName: "packingDate", width: "25%" },
    { columnName: "actions", width: "25%" },
  ]);
  const [headerExtension] = useState([
    { columnName: "jobId", width: "auto" },
    { columnName: "assignmentName", width: "auto" },
    { columnName: "packingDate", width: "auto" },
    { columnName: "actions", width: "auto" },
  ]);

  if (!props.loadingTable) {
    return (
      <React.Fragment>
        <Grid rows={props.rows} columns={props.columns} getRowId={getRowId}>
          <SortingState
            defaultSorting={[{ columnName: props.sortIt, direction: "asc" }]}
          />
          <IntegratedSorting />
          <SearchState />
          <IntegratedFiltering />
          <Table
            columnExtensions={tableColumnExtensions}
            cellComponent={props.cell}
          />
          <TableHeaderRow
            columnExtensions={headerExtension}
            showSortingControls={true}
          />
          <Toolbar />
          <SearchPanel />
        </Grid>
      </React.Fragment>
    );
  } else {
    return <div></div>;
  }
}
